<template>
  <div class="card-wrapper t-grey" style="width: 260px;">
    <span
      v-line-clamp="2" class="mb-0 t-500 t-lr"
      v-html="name"
    />

    <div class="card-body-graph">
      <ul style="padding: 0; list-style: none;">
        <partial-owners v-if="!isEmpty(data.owners)"
          :lineClamp="1"
          :owners="owners"
          :totalOwners="data.researchers_count"
          :highlights="highlightResearchers"
          :highlightKeys="['researchers.full_name.normalized', 'researchers.initial_name.normalized']"
          :renderWithLinkTo="false">
        </partial-owners>

        <partial-organisation v-if="!isEmpty(data.organisations)"
          :organisations="data.organisations"
          :highlights="highlightOrganisations"
          :highlightKey="'organisations.name'"
          :lineClamp="1">
        </partial-organisation>

        <matches v-if="!isEmpty(matches)" :matches="matches" class="mt-3" />

        <comparison-chart
          :isLoaded="isLocalGraphDataLoaded"
          :graphData="localGraphData"
          :hasError="hasErrorGraphData"
          hideLegendTooltip
        />
      </ul>
    </div>
  </div>
</template>

<script>
import processing from '@/mixins/search/results/researchGroup'
import searchResultVisuals from '@/mixins/search/results/visuals'

import Matches from '@/components/search/results/partials/Matches'
import PartialOrganisation from '@/components/search/results/partials/OrganisationsForBody'
import ComparisonChart from '@/components/shared/chart/ComparisonChart'
import PartialOwners from '@/components/search/results/partials/OwnersForBody'

export default {
  name: 'researcherResultBlock',
  mixins: [processing, searchResultVisuals],
  components: {
    Matches,
    PartialOrganisation,
    ComparisonChart,
    PartialOwners
  }
}
</script>
